// NPM imports

import React, { Component } from 'react';
import { connect } from 'react-redux';

// Project imports

import Modal from '../../../components/Modal';
import AlertMessage from '../../../components/AlertMessage';
import LoadMask from '../../../components/LoadMask';
import { updatePassword } from '../../../redux/auth';
import { getUpdatePasswordUI } from '../../../redux/selectors';

// Module imports

import ChangePasswordForm from './ChangePasswordForm';

// Component

class ChangePasswordModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSuccessMessage: false,
    };
  }

  _submit = ({ currentPassword, newPassword }) => {
    const { dispatch } = this.props;

    dispatch(updatePassword(currentPassword, newPassword)).then(
      () => {
        this.setState({ showSuccessMessage: true });
      },
      // error
      () => {},
    );
  };

  _renderContent = () => {
    const { ui } = this.props;

    if (this.state.showSuccessMessage) {
      return (
        <AlertMessage box success message="Senha atualizada com sucesso" />
      );
    }

    return (
      <div>
        <p>
          Visando sua segurança, pedimos para que você altere a senha que
          recebeu por e-mail para uma senha de sua preferência antes de começar
          a utilizar a plataforma.
        </p>
        <ChangePasswordForm ui={ui} onSubmit={this._submit} />
      </div>
    );
  };

  render() {
    const { ui, ...props } = this.props;

    return (
      <Modal title="Alterar senha" size="small" {...props}>
        {this._renderContent()}
        {ui.isFetching && <LoadMask text="Alterando..." />}
      </Modal>
    );
  }
}

// Redux

const mapStateToProps = state => ({
  ui: getUpdatePasswordUI(state),
});

export default connect(mapStateToProps)(ChangePasswordModal);
